import React, { useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import InvoiceReport from './InvoiceReport';
import { generatePDF } from '../../../utils/reportUtils';
import ReportDialog from '../ReportDialog';
import { InvoiceDetailsResponse } from '../../../pages/Billing/Invoice/newInvoice/newInvoice.types';

type Props = {
  open: boolean;
  onClose: () => void;
  data: InvoiceDetailsResponse | null;
  isLoading?: boolean;
  error?: string | null;
};

const InvoiceReportGen: React.FC<Props> = ({
  open,
  onClose,
  data,
  isLoading = false,
  error = null,
}) => {
  const reportRef = useRef<HTMLDivElement>(null);

  const handleDownloadPDF = () => {
    if (reportRef.current && data) {
      generatePDF(reportRef.current, `Invoice_${data.bill_number}`);
    }
  };

  const handlePrint = () => window.print();

  return (
    <ReportDialog
      open={open}
      onClose={onClose}
      title="Invoice"
      onDownload={data ? handleDownloadPDF : undefined}
      onPrint={data ? handlePrint : undefined}
      downloadLabel="Download Invoice"
      printLabel="Print Invoice"
    >
      {isLoading ? (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <CircularProgress size={40} />
          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            Loading invoice...
          </Typography>
        </Box>
      ) : error ? (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'error.main' }}>
            {error}
          </Typography>
        </Box>
      ) : data ? (
        <div ref={reportRef}>
          <InvoiceReport invoiceData={data} />
        </div>
      ) : (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            No invoice data available.
          </Typography>
        </Box>
      )}
    </ReportDialog>
  );
};

export default InvoiceReportGen;
